import React, { useState } from "react"
import styled, { css } from 'styled-components'
import useUpdateEffect from '@hooks/useUpdateEffect'
import { modifier } from '@styles/mixins'
import { colors } from "@styles/vars"

export default function Hamburger({ opened: openedProp = false, action, onChange }: HamburgerProps) {
    const [opened, setOpened] = useState<boolean>(openedProp)

    const handleClick = () => {
        setOpened(old => !old)
        onChange?.(opened)
        action?.()
    }

    useUpdateEffect(() => {
        if (opened === openedProp)
            return

        setOpened(openedProp)
    }, [openedProp])

    return (
        <HamburgerButton opened={opened} onClick={handleClick}>
            <HamburgerLine />
            <HamburgerLine />
            <HamburgerLine />
        </HamburgerButton>
    )
}

// STYLES
const HamburgerLine = styled.div`
    background: ${colors.black};
    height: 2px;
    flex-shrink: 0;
    width: 100%;

    transition: .4s ease-out;

    &:nth-child(2) {
      width: 40%;
    }

    &:nth-child(3) {
      width: 70%;
    }
`

const HamburgerButton = styled.button<{ opened: boolean }>`
    width: 30px;
    height: 21px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;

    /* rewrites button styles */
    background: transparent;
    border: 0;
    padding: 0;

    /* Asserts hamburger will be the same size within every block */
    flex-shrink: 0;
    min-width: 30px;

    ${modifier("opened", css`
        ${HamburgerLine}:nth-child(2) {
            opacity: 0;
            width: 0;
        }

        ${HamburgerLine}:nth-child(1) {
            width: 70%;
            transform: rotate(-45deg) translateY(7px) translateX(-7px);
        }

        ${HamburgerLine}:nth-child(3) {
            transform: rotate(45deg) translateY(-7px) translateX(-7px);
        }
    `)}
`

// TYPES
interface HamburgerProps {
    opened?: boolean
    action?(): void
    onChange?(opened: boolean): void
}